<template>
  <div class="con-left">
    <p class="title" v-show="peroidType === BEFORE_PEROID">
      <span>다음 수강신청 기간</span>을<br />
      확인해주세요
    </p>
    <p class="title" v-show="peroidType === CUR_PEROID">
      <span>{{ chasuName }}<br />수강신청 기간</span>입니다
    </p>

    <p class="title" v-show="isEndOrNext">
      <span
        >수강신청이 <br />
        종료</span
      >되었습니다
    </p>
    <p
      class="date"
      v-show="
        peroidType === CUR_PEROID ||
        peroidType === NEXT_PEROID ||
        peroidType === BEFORE_PEROID
      "
    >
      {{ compStDt }} ~ {{ compEndDt }}
    </p>
    <p class="date" v-show="isEndOrNext">
      다음에 더 좋은 과정으로 찾아뵙겠습니다
    </p>
    <ul>
      <li
        class="go-courses"
        :style="
          (!chkUserInfo && peroidType === CUR_PEROID) ||
          peroidType === BEFORE_PEROID
            ? { width: 'auto' }
            : { width: '100%' }
        "
        @click="applyCourse(isEndOrNext ? 'history' : 'apply')"
        v-show="peroidType === CUR_PEROID || isEndOrNext"
      >
        {{ isEndOrNext ? "수강신청 내역 확인하기" : "수강신청하기" }}
      </li>
      <li
        :class="active ? 'no-check-courses' : 'check-courses'"
        v-show="
          (!chkUserInfo && peroidType === CUR_PEROID) ||
          peroidType === BEFORE_PEROID
        "
        @click="applyCourse('history')"
      >
        수강신청 내역 확인하기
      </li>
    </ul>
  </div>
  <div class="con-right">
    <div v-show="peroidType === CUR_PEROID">
      <p>신청현황</p>
      <ul>
        <li
          v-for="(applyItem, applyIndex) in statusList"
          :key="'apply' + applyIndex"
          :class="applyItem.status === '신청마감' ? 'clr-blue' : ''"
        >
          ·{{ applyItem.courseName }} : {{ applyItem.status }}
        </li>
      </ul>
    </div>
  </div>
  <ModalPopup :visible="cerModal" @closeModal="onCloseModal" />
</template>

<script setup>
import ModalPopup from "@/components/ModalPopup.vue";
import { computed, onMounted, ref, watch } from "@vue/runtime-core";
import { getItmSugangStatus, itmSugangCodeInfo } from "@/api/itmApi/index";
import { getCtmSugangStatus } from "@/api/ctmApi/index";
import { useStore } from "vuex";
import _ from "lodash";
import { useRouter } from "vue-router";
import { certModalOpen } from "@/utils/utils";

//기간 타입
const CUR_PEROID = 1; // 현재 기간
const NEXT_PEROID = 2; // 현재 기간이 아니면서 다음 차수 존재
const END_PEROID = 3; // 현재기간이 아니면서 다음차수 존재 X
const BEFORE_PEROID = 4; // 현재 수강신청 이전인 경우

const props = defineProps({
  /* 플랫폼 명 */
  pltName: {
    type: String,
    required: false,
    default: "",
  },
  /* 플랫폼 시작기간 */
  pltStDt: {
    type: String,
    required: false,
    default: "",
  },
  /* 플랫폼 종료기간 */
  pltEndDt: {
    type: String,
    required: false,
    default: "",
  },
  /* 플랫폼 과정리스트 */
  applyStatusList: {
    type: Object,
    required: false,
    default() {
      return [];
    },
  },
  /* 다음차수 사용여부 */
  nextChasu: {
    type: String,
    required: false,
    default: "N",
  },
  /* 비활성화 여부 */
  closeYn: {
    type: String,
    required: false,
    default: "N",
  },
  /* 차수명 */
  chasuName: {
    type: String,
    required: false,
    default: "",
  },
  /* 수업 상태*/
  status: {
    type: String,
    required: false,
    default: "",
  },
});

const emit = defineEmits(["showClassHistory", "successAuth"]);

const peroidType = ref(0);
const statusList = ref([]);
const store = useStore();
const cerModal = ref(false);
const router = useRouter();
const active = ref(false);
const btnType = ref("");
const chkUserInfo = ref(
  Object.keys(store.getters.getUserInfo).length == 0 ? false : true,
);

const dateString = (val) => {
  if (val) {
    const dateSplit1 = val.split(" ")[0];
    const dateSplit2 = val.split(" ")[1];

    const hh = dateSplit2.split(":")[0];
    const mm = dateSplit2.split(":")[1];

    return `${dateSplit1} ${hh}:${mm}`;
  }

  return "";
};

const compStDt = computed(() => {
  let str = "";
  const copyStDt = _.clone(props.pltStDt);

  if (copyStDt) {
    str = dateString(copyStDt);
  }

  return str;
});

const isEndOrNext = computed(
  () => peroidType.value === NEXT_PEROID || peroidType.value === END_PEROID,
);

const compEndDt = computed(() => {
  let str = "";
  const copyEndDt = _.clone(props.pltEndDt);

  if (copyEndDt) {
    str = dateString(copyEndDt);
  }

  return str;
});

const setPeroid = (statusText) => {
  const { nextChasu } = props;

  if (statusText === "예정") {
    peroidType.value = BEFORE_PEROID;
  } else if (statusText === "진행") {
    peroidType.value = CUR_PEROID;
  } else if (statusText === "종료") {
    //다음 차수 존재 할 경우 NEXT_PEROID
    if (nextChasu === "Y") {
      peroidType.value = NEXT_PEROID;
    } else {
      peroidType.value = END_PEROID;
    }
  }
};

const getItmSugangInfo = async (code) => {
  try {
    const { data } = await getItmSugangStatus(code);
    const { data: respData } = data;
    store.commit("setItmPageIdx", respData.pageIdx);
    return respData;
  } catch (error) {
    console.error("getItmSugangInfo error : ", error);
    return {};
  }
};

const sugangCompleteList = () => {
  alert("화면 준비중입니다.");
};

const getCtmSugangInfo = async (code) => {
  try {
    const { data } = await getCtmSugangStatus(code);
    const { data: respData } = data;
    return respData;
  } catch (error) {
    console.error("getCtmSugangInfo error : ", error);
    return {};
  }
};

const setApplyStatusList = async (list) => {
  const qaList = [];
  let itmPageIdx = -1;
  let quAdminInfoList = [];
  const filterList = list.filter((item) => item["isUse"] === "Y");
  try {
    for (let i = 0; i < filterList.length; i++) {
      let status = "";
      if (filterList[i]["courseType"] === "itm") {
        //ITM API
        const {
          status: st,
          pageIdx,
          qaAdminInfo,
        } = await getItmSugangInfo(filterList[i]["code"]);
        status = st;
        itmPageIdx = pageIdx;
        quAdminInfoList = qaAdminInfo;
      } else if (filterList[i]["courseType"] === "ctm") {
        //CTM API
        const { status: st, qaAdminInfo } = await getCtmSugangInfo(
          filterList[i]["code"],
        );

        status = st;
        quAdminInfoList = qaAdminInfo;
      }

      statusList.value.push({
        courseName: filterList[i]["courseName"],
        courseType: filterList[i]["courseType"],
        status: status,
      });

      //setQaList

      for (let qaIdx = 0; qaIdx < quAdminInfoList.length; qaIdx++) {
        if (quAdminInfoList[qaIdx].includes("고객센터")) {
          continue;
        }

        qaList.push({
          courseName: filterList[i]["courseName"],
          itmPageIdx,
          qaManager: quAdminInfoList[qaIdx],
          courseType: filterList[i]["courseType"],
        });
      }
    }

    store.commit("setFooterInfo", {
      qaList: qaList,
    });

    //setFooterInfo commit
  } catch (error) {
    console.error("setApplyStatusList error : ", error);
    store.commit("setFooterInfo", {
      qaList: [],
    });
  }
};

const isSelectItm = async (code) => {
  return await itmSugangCodeInfo(code);
};

const applyCourse = async (type = "apply") => {
  btnType.value = type;
  if (type === "history") {
    cerModal.value = true;
    return;
  }

  const { applyStatusList } = props;
  const fil = applyStatusList.filter(
    (courseItem) => courseItem["isUse"] === "Y",
  );

  if (fil.length > 1) {
    router.push(`/courseSelect`);
  } else if (fil.length === 1) {
    store.commit("setSelectCourseItem", fil[0]);
    const { courseType, code, idx: courseIdx } = fil[0];

    store.commit("setCourseIdx", courseIdx);
    if (courseType === "itm") {
      const resp = await isSelectItm(code);
      const { success, data: respData } = resp.data;
      if (success) {
        const { pageIdx } = respData;
        //ITM 정보 세팅
        store.commit("setItmSugangInfo", {
          pageIdx,
          programIdx: -1,
          subjectIdx: -1,
        });
      }
    } else {
      const { data } = await getCtmSugangStatus(code);
      const { data: respData } = data;
      const { status } = respData;
      if (status !== "신청가능") {
        alert(`현재 수강신청 기간이 아닙니다.`);
        return false;
      }
      let clone = _.cloneDeep(store.getters.getCtmSugangInfo);

      if (clone) {
        clone["code"] = code;
      } else {
        clone = {
          code: code,
        };
      }

      store.commit("setCtmSugangInfo", clone);
    }
    router.push(`/common/introuduceClass?type=${courseType}`);
  } else {
    alert(`등록된 과정이 없습니다.\n매니저에게 문의해주세요`);
  }
};

const onCloseModal = (isSuccessAuth) => {
  cerModal.value = false;

  // history 타입은 인증만 필요하므로 재호출 시 모달이 다시 열리는 것을 방지
  if (isSuccessAuth && btnType.value !== "history") {
    applyCourse(btnType.value);
  }
};

onMounted(() => {
  const { applyStatusList, status } = props;
  statusList.value.length = 0;
  if (status) {
    setPeroid(status);
  }

  if (applyStatusList.length > 0) {
    setApplyStatusList(applyStatusList);
  }
});

//로그인 정보 변경
watch(
  () => store.getters.getUserInfo,
  (cur) => {
    if (Object.keys(cur).length == 0) {
      //변경된 객체의 길이가 0이면 빈값 , 사용자 정보 없음
      chkUserInfo.value = false;
    } else {
      chkUserInfo.value = true;
    }
  },
);
</script>

<style lang="scss" scoped>
.con-left {
  flex: none;
  position: relative;
  top: 77px;
  .title {
    font-size: 55px;
    line-height: 71px;
    margin-bottom: 16px;

    span {
      font-weight: $bold;
    }
  }

  .date {
    font-size: 22px;
    margin-bottom: 30px;
  }

  ul {
    display: flex;
    gap: 0 23px;
    position: absolute;
    bottom: 111px;
    width: 100%;

    li {
      text-align: center;
      font-size: 20px;
      font-weight: $medium;
      padding: 15px 35px;
      border-radius: 30px;
      cursor: pointer;
    }

    .go-courses {
      color: $white;
      background-color: $blue;
    }

    .check-courses {
      color: $gray-808080;
      background-color: $gray-f6f7f8;
      border: 1px solid $gray-808080;
    }

    .no-check-courses {
      border: 1px solid $black-000;
    }
  }
}

.con-right {
  flex: none;
  position: relative;
  width: 1026px;
  height: 395px;
  background: url(@/assets/imgs/main/term-bg.png) no-repeat center / cover;

  > div {
    position: absolute;
    left: 215px;
    bottom: -39px;
    width: 449px;
    padding: 24px 30px;
    background-color: #a6caff;
    opacity: 0.8;

    p {
      font-size: 17px;
      font-weight: $bold;
      padding-bottom: 7px;
      border-bottom: 2px solid $black;
      margin-bottom: 18px;
    }

    ul {
      display: flex;
      flex-direction: column;
      gap: 7px 0;
      font-size: 15px;

      .clr-blue {
        color: $blue;
      }
    }
  }
}
</style>
